import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CouponCarouselComponent, QrCodeCouponComponent } from "@app-cmc/features/common";
import { SharedModule } from "@app-cmc/shared";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { QrCodeReaderButtonComponent } from "clearline-common";
import { SimplebarAngularModule } from "simplebar-angular";
import { BadgetsSelectionComponent } from "./badgets-selection/badgets-selection.component";
import { QrCodeFullPreviewModalComponent, QrCodePreviewComponent } from "./qr-code-preview";
import { RecepientItemComponent } from "./recipient-item/recipient-item.component";
import { RecipientsComponent } from "./recipients/recipients.component";

@NgModule({
  declarations: [
    RecepientItemComponent,
    BadgetsSelectionComponent,
    RecipientsComponent,
    QrCodeFullPreviewModalComponent,
    QrCodePreviewComponent,
    CouponCarouselComponent,
    QrCodeCouponComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslocoModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SimplebarAngularModule,
    QrCodeReaderButtonComponent
  ],
  exports: [
    CommonModule,
    SharedModule,
    TranslocoModule,
    FormsModule,
    ReactiveFormsModule,
    RecepientItemComponent,
    BadgetsSelectionComponent,
    RecipientsComponent,
    QrCodePreviewComponent,
    CouponCarouselComponent,
    QrCodeCouponComponent
  ]
})
export class CommonFeatureModule {}
